
import React from 'react'
import {Container} from "./Container";

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import {IColumn, IColumnsList} from "../interfaces";

export class ColumnList extends React.Component<IColumnsList, any>{
  render() {
    return (
      <div className="App">
        <DndProvider backend={HTML5Backend}>
          {/*<Example */}
          {/*/>*/}
          <Container
            isColumnsPopUpOpen={this.props.isColumnsPopUpOpen}
            toggleColumnPopUp={(isOpen, columnID) => this.props.toggleColumnPopUp(isOpen, columnID)}
            reportColumns={this.props.reportColumns}
            updateColumnsOrder={(columnIDs: number[]) => this.props.updateColumnsOrder(columnIDs)}
          />
        </DndProvider>
      </div>
    )
  }
}
